import {
  Typography, TextField, FormHelperText, FormControl, Box, Button,
  IconButton,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { InputLabel, Select, MenuItem } from "@mui/material";
import axios from '../../api/axios';

const POST_TIMESCHEDULE = "/timertriggerscheduler";
const GET_SUPERADMINSETTINGS = "/superAdminSettings";
const TOTAL_CONTAINERS = 28;


export const GlobalSettings = () => {

  const durations = [
    { label: "5 minutes", value: 5, timer: "0 */5 * * * *" },
    { label: "10 minutes", value: 10, timer: "0 */10 * * * *" },
    { label: "30 minutes", value: 30, timer: "0 */30 * * * *" },
    { label: "1 hour", value: 60, timer: "0 0 * * * *" },
    { label: "6 hours", value: 360, timer: "0 0 */6 * * *" },
    { label: "24 hours", value: 1440, timer: "0 0 0 * * *" },
  ];

  const dailyTime = [
    { label: "Daily 00:00 UTC", value: "00:00", timer: "0 0 0 * * *" },
    { label: "Daily 01:00 UTC", value: "01:00", timer: "0 0 1 * * *" },
    { label: "Daily 02:00 UTC", value: "02:00", timer: "0 0 2 * * *" },
    { label: "Daily 03:00 UTC", value: "03:00", timer: "0 0 3 * * *" },
    { label: "Daily 04:00 UTC", value: "04:00", timer: "0 0 4 * * *" },
    { label: "Daily 05:00 UTC", value: "05:00", timer: "0 0 5 * * *" },
    { label: "Daily 06:00 UTC", value: "06:00", timer: "0 0 6 * * *" },
    { label: "Daily 07:00 UTC", value: "07:00", timer: "0 0 7 * * *" },
    { label: "Daily 08:00 UTC", value: "08:00", timer: "0 0 8 * * *" },
    { label: "Daily 09:00 UTC", value: "09:00", timer: "0 0 9 * * *" },
    { label: "Daily 10:00 UTC", value: "10:00", timer: "0 0 10 * * *" },
    { label: "Daily 11:00 UTC", value: "11:00", timer: "0 0 11 * * *" },
    { label: "Daily 12:00 UTC", value: "12:00", timer: "0 0 12 * * *" },
    { label: "Daily 13:00 UTC", value: "13:00", timer: "0 0 13 * * *" },
    { label: "Daily 14:00 UTC", value: "14:00", timer: "0 0 14 * * *" },
    { label: "Daily 15:00 UTC", value: "15:00", timer: "0 0 15 * * *" },
    { label: "Daily 16:00 UTC", value: "16:00", timer: "0 0 16 * * *" },
    { label: "Daily 17:00 UTC", value: "17:00", timer: "0 0 17 * * *" },
    { label: "Daily 18:00 UTC", value: "18:00", timer: "0 0 18 * * *" },
    { label: "Daily 19:00 UTC", value: "19:00", timer: "0 0 19 * * *" },
    { label: "Daily 20:00 UTC", value: "20:00", timer: "0 0 20 * * *" },
    { label: "Daily 21:00 UTC", value: "21:00", timer: "0 0 21 * * *" },
    { label: "Daily 22:00 UTC", value: "22:00", timer: "0 0 22 * * *" },
    { label: "Daily 23:00 UTC", value: "23:00", timer: "0 0 23 * * *" },
  ];

  const [selectedDurationAPI, setSelectedDurationAPI] = useState("");
  const [selectedDurationConv, setSelectedDurationConv] = useState("");
  const [selectedDurationWeb, setSelectedDurationWeb] = useState("");
  const [selectReportSchedule, setSelectReportSchedule] = useState("");
  const [criticalWebhook, setCriticalWebhook] = useState("");
  const [reportChannel, setReportChannel] = useState("");
  const token = localStorage.getItem('token');

  useEffect(() => {
    const requestData = {
      token: token,
      getSuperadminSettings: true
    };

    axios.post(GET_SUPERADMINSETTINGS, requestData)
      .then((res) => {
        if (res?.status === 200) {
          const convCron = res.data?.message?.superadminsettings.converterTimerSchedule;
          const apiCron = res.data?.message?.superadminsettings.apiTimerSchedule;
          const webCron = res.data?.message?.superadminsettings.consoleTimerSchedule;
          const reportCron = res.data?.message?.superadminsettings.reportApiTimerSchedule;

          const convMatch = durations.find(d => d.timer === convCron);
          const apiMatch = durations.find(d => d.timer === apiCron);
          const webMatch = durations.find(d => d.timer === webCron);
          const reportMatch = dailyTime.find(d => d.timer === reportCron);

          setSelectedDurationConv(convMatch ? convMatch.value : durations[0].value);
          setSelectedDurationAPI(apiMatch ? apiMatch.value : durations[0].value);
          setSelectedDurationWeb(webMatch ? webMatch.value : durations[0].value);
          setSelectReportSchedule(reportMatch ? reportMatch.value : dailyTime[0].value);
          setCriticalWebhook(res.data?.message?.superadminsettings.slackWebhookAlerts);
          setReportChannel(res.data?.message?.superadminsettings.slackWebhookReports);

        } else if (res?.status === 400) {
          console.log("Bad Request:", res.data);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  }, [token]);

  const converterTimeScheduler = (value) => {
    const selectedTimer = durations.find(d => d.value === value);

    const requestConvScheduler = {
      converterTimeSchedule: true,
      schedule: selectedTimer.timer
    };

    axios.post(POST_TIMESCHEDULE, requestConvScheduler).then((response) => {
      if (response?.status === 200) {
        console.log("Data is saved.");
      } else if (response?.status === 400) {
        console.log("Bad Request:", response.data);
      }
    })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const apiTimeScheduler = (value) => {
    const selectedTimer = durations.find(d => d.value === value);

    const requestAPIScheduler = {
      apiTimeSchedule: true,
      schedule: selectedTimer.timer
    };

    axios.post(POST_TIMESCHEDULE, requestAPIScheduler).then((response) => {
      if (response?.status === 200) {
        console.log("Data is saved.");
      } else if (response?.status === 400) {
        console.log("Bad Request:", response.data);
      }
    })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const consoleTimeScheduler = (value) => {
    const selectedTimer = durations.find(d => d.value === value);

    const requestConsoleScheduler = {
      consoleTimeSchedule: true,
      schedule: selectedTimer.timer
    };

    axios.post(POST_TIMESCHEDULE, requestConsoleScheduler).then((response) => {
      if (response?.status === 200) {
        console.log("Data is saved.");
      } else if (response?.status === 400) {
        console.log("Bad Request:", response.data);
      }
    })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const reportAPITestTimeScheduler = (value) => {
    const selectedTimer = dailyTime.find(d => d.value === value);

    const requestScheduler = {
      reportApiTest: true,
      schedule: selectedTimer.timer //change to time at day
    };

    axios.post(POST_TIMESCHEDULE, requestScheduler).then((response) => {
      if (response?.status === 200) {
        console.log("Data is saved.");
      } else if (response?.status === 400) {
        console.log("Bad Request:", response.data);
      }
    })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const criticalAlertsChannelValue = (value) => {
    const requestAlertScheduler = {
      crtiticalAlertValue: true,
      channelLink: value
    };

    axios.post(POST_TIMESCHEDULE, requestAlertScheduler).then((response) => {
      if (response?.status === 200) {
        console.log("Data is saved.");
      } else if (response?.status === 400) {
        console.log("Bad Request:", response.data);
      }
    })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const reportChannelValue = (value) => {
    const requestReportScheduler = {
      reportChannelValue: true,
      reportLink: value
    };

    axios.post(POST_TIMESCHEDULE, requestReportScheduler).then((response) => {
      if (response?.status === 200) {
        console.log("Data is saved.");
      } else if (response?.status === 400) {
        console.log("Bad Request:", response.data);
      }
    })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  return (
    <Box display="flex" height="100%">
      <Box flexGrow={1} pl={3} sx={{ ml: "48px" }}>
        <Typography variant="h2" gutterBottom sx={{ mb: '24px', mt: '24px', marginLeft: '-24px' }}>
          Global Settings
        </Typography>

        <Typography variant="h6" fontWeight="medium" letterSpacing="0.15px" lineHeight="160%" gutterBottom sx={{ mt: '24px', mb: '0px' }}>
          Monitoring & Alerts
        </Typography>

        <Typography variant="body1" color="text.secondary" gutterBottom sx={{ mt: '-5px' }}>
          Set frequency and channels
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ ml: '8px', mt: '15px', fontSize: 20 }}>
          Health Check Frequency
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 0,
            width: 330,
            ml: '8px'
          }}
        >

          <FormControl variant="standard" sx={{ width: 330, mt: '24px' }}>
            <InputLabel id="api-select-label">API Core Tests</InputLabel>
            <Select labelId="api-test-select-label" value={selectedDurationAPI}
              onChange={(e) => {
                setSelectedDurationAPI(e.target.value);
                apiTimeScheduler(e.target.value);
              }}
            >
              {durations.map((d) => (
                <MenuItem key={d.value} value={d.value} /* disabled={!b.hasData}*/>
                  {d.label}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText id="api-select-label">How frequently should API tests run?</FormHelperText>
          </FormControl>

          <FormControl variant="standard" sx={{ width: 330, mt: '24px' }}>
            <InputLabel id="conv-select-label">Converter Core Tests</InputLabel>
            <Select labelId="conv-test-select-label" value={selectedDurationConv}
              onChange={(e) => {
                setSelectedDurationConv(e.target.value);
                converterTimeScheduler(e.target.value);
              }}
            >
              {durations.map((d) => (
                <MenuItem key={d.value} value={d.value} /* disabled={!b.hasData}*/>
                  {d.label}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText id="conv-select-label">How frequently should converter tests run?</FormHelperText>
          </FormControl>

          <FormControl variant="standard" sx={{ width: 330, mt: '24px', mb: '24px' }}>
            <InputLabel id="web-select-label">Web Console Core Tests</InputLabel>
            <Select labelId="web-test-select-label" value={selectedDurationWeb}
              onChange={(e) => {
                setSelectedDurationWeb(e.target.value);
                consoleTimeScheduler(e.target.value);
              }}
            >
              {durations.map((d) => (
                <MenuItem key={d.value} value={d.value} /* disabled={!b.hasData}*/>
                  {d.label}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText id="conv-select-label">How frequently should web console tests run?</FormHelperText>
          </FormControl>
        </Box>

        <Typography variant="h6" gutterBottom sx={{ ml: '8px', mt: '15px', fontSize: 20 }}>
          Reporting
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 0,
            width: 330,
            ml: '8px'
          }}
        >

          <FormControl variant="standard" sx={{ width: 330, mt: '24px' }}>
            <InputLabel id="api-select-label">Report Schedule</InputLabel>
            <Select labelId="api-test-select-label" value={selectReportSchedule}
              onChange={(e) => {
                setSelectReportSchedule(e.target.value);
                reportAPITestTimeScheduler(e.target.value);
              }}
            >
              {dailyTime.map((d) => (
                <MenuItem key={d.value} value={d.value} /* disabled={!b.hasData}*/>
                  {d.label}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText id="api-select-label">When should summary reports be sent?</FormHelperText>
          </FormControl>

          <TextField variant="standard" label="Critical Alerts Channel" helperText="Enter the Slack Webhook URL for critical alerts"
            value={criticalWebhook} sx={{ width: 800, mt: 3 }}
            onChange={(e) => {
              setCriticalWebhook(e.target.value.toString());
              criticalAlertsChannelValue(e.target.value.toString());
            }}
          >
          </TextField>

          <TextField input variant="standard" label="Report Channel" helperText="Enter the Slack Webhook URL for summary reports"
            value={reportChannel} sx={{ width: 800, mt: 3 }}
            onChange={(e) => {
              setReportChannel(e.target.value.toString());
              reportChannelValue(e.target.value.toString());
            }}
          >
          </TextField>

        </Box>
      </Box>
    </Box>
  )
}